<div class="modal-backdrop-wrapper" *ngIf="isFullScreen">
  <div class="modal-backdrop" (click)="onCloseCommunicationModal()"></div>
</div>

<div
  [ngClass]="{
    'communication-modal': true,
    'modal-fullscreen': isFullScreen,
    'modal-default': !isFullScreen
  }"
>
  <div class="modal-header">
    <div>
      <button nz-button nzType="text" nzShape="circle" (click)="toggleFullScreen()">
        <i *ngIf="!isFullScreen" nz-icon nzType="fullscreen"></i>
        <i *ngIf="isFullScreen" nz-icon nzType="fullscreen-exit"></i>
      </button>
    </div>
    <div class="modal-title">Communication</div>
    <div>
      <button nz-button nzType="text" nzShape="circle" (click)="onCloseCommunicationModal()">
        <i nz-icon nzType="close"></i>
      </button>
    </div>
  </div>

  <div class="modal-body">
    <div class="modal-pages">
      <ng-container [ngSwitch]="communicationContent">
        <app-communication-requests *ngSwitchCase="CommunicationContent.MAIN_REQUESTS" [isFullScreen]="isFullScreen"/>
        <app-communication-submit-request *ngSwitchCase="CommunicationContent.SUBMIT_REQUESTS" />
        <ng-container *ngIf="!isFullScreen">
          <app-communication-chat *ngSwitchCase="CommunicationContent.REQUEST_CHAT" />
        </ng-container>
      </ng-container>
    </div>
    <div class="modal-chat" *ngIf="isFullScreen">
      <app-communication-chat [isFullScreen]="isFullScreen" />
    </div>
  </div>
</div>
